import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import LeftNavigationMenu from "../navigation/leftNavigation/LeftNavigationMenu";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import DropdownWrapper from "../form/DropdownWrapper";
import Image from "../elements/Image";
import { classNames } from "src/helpers/classNames";
import { RectangleStackIcon, ArrowRightStartOnRectangleIcon, KeyIcon, Bars3BottomLeftIcon, ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { AuthContext } from "src/context/auth";
import { WorkspaceContext } from "src/context/workspace";
import { apiRequest } from "src/async/apiUtils";
import UserDropdown from "../shared/UserDropdown";
import { logoutRedirect } from "src/async/fetch";
import UserImage from "src/assets/images/user.jpg";
import { toast } from "react-toastify";
import Modal from "../shared/Modal";
import Input from "src/components/form/Input";
import { useAsyncAction } from "src/hooks/useAsyncAction";
import ResetPasswordForm from "src/pages/forgot-password/ResetPasswordForm";
import CustomModal from "../shared/CustomModal";
import ManagePayments from "src/pages/ManagePayments";
import SlideOver from "../shared/SlideOver";
import { isA2HSDismissedForWS, setA2HSDismissedForWS } from "src/helpers";
import AddToHomeScreen from "../AddToHomeScreen";
import HeaderMenus from "../navigation/HeaderMenus";
import { outerPages } from "src/config/host";
import { useWorkspaceManager } from "src/hooks/useWorkspaceManager";
import { getUserMenuData, isPasswordInvalid } from "src/helpers/userHelper";
import { Settings } from "../shared/Settings/Settings";
import useActivePage from "src/hooks/useActivePage";
import { useHeaderMenus } from "src/hooks/useHeaderMenus";
import { useSiteSettings } from "src/context/SiteSettingsContext";
import { Tooltip } from "react-tooltip";

const MordernDesign = ({ menusLoaded, mordernDesign, isNotification, sidepanelWidth, isMenu, setIsMenu, menus, setMenus, simulatedMenus, setSimulatedMenus, keyword, setKeyword, handleMenuClick, menuType, device }) => {
  const { workspace_id, content_value } = useParams();
  const { site } = useSiteSettings();
  const { user } = useContext(AuthContext);
  const { loading, currentLogo, switchAdminButtonDisabled, clickWorkspace, loadPlanDetails, navigateToPaymemnts, extractWorkspaceName, loadImage, onHandleSwitchToAdmin, navigateToSettings, settingsSlider, setSettingsSlider } = useWorkspaceManager();
  const { list: workspaces, details: workspaceDetails, workspacePaymentModalOpen, setWorspacePaymentModalOpen = () => {}, planDetails, params, setParams } = useContext(WorkspaceContext);

  const navigate = useNavigate();

  const [userMenu, setUserMenu] = useState(null);
  const [overflowedHeaderMenus, setOverflowedHeaderMenus] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);

  const passwordValidation = !password || !confirmPassword || !oldPassword || password !== confirmPassword || isPasswordInvalid(password, site.password_policy);

  const payment_required = window.location.href.includes("/payment-required");
  const isOuterPage = outerPages.includes(window.location.href);
  const isExtension = window.location.protocol === "chrome-extension:";

  const {
    loading: changePasswordLoading,
    success: changePasswordSuccess,
    execute: changePasswordAction,
  } = useAsyncAction({
    onSuccess: (res) => {
      const resData = res.data;
      if (resData.status === 200) {
        setIsOpenModal(false);

        clearChangePasswordModalValues();
      } else {
        toast.error(resData.message);
        clearChangePasswordModalValues();
      }
    },
    onError: (error) => {
      toast.error(error.message);
      clearChangePasswordModalValues();
    },
  });

  const { menus: headerMenus } = useHeaderMenus({
    workspaceId: workspace_id,
    userId: user?._id,
    paymentRequired: payment_required,
  });

  useEffect(() => {
    const dropdownData = getUserMenuData({
      user,
      workspaceDetails,
      overflowedHeaderMenus,
      setIsOpenModal,
      logout,
      UserImage,
      KeyIcon,
      ArrowRightStartOnRectangleIcon,
      onHandleSwitchToAdmin,
      navigateToPaymemnts,
      navigateToSettings,
      switchAdminButtonDisabled,
      navigateToTravel,
      site,
    });

    setUserMenu({
      image: UserImage,
      name: "Administrator",
      dropdownData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.type, window.location.href, workspaceDetails, user?._id, overflowedHeaderMenus, window.innerWidth, site?.travel_enabled]);

  const navigateToTravel = () => {
    navigate("/travel/dashboard");
  };

  const clearChangePasswordModalValues = () => {
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
  };

  const changePassword = async () => {
    changePasswordAction(async () => {
      return await apiRequest("post", "/portal/user/self/change-password", {
        body: {
          old_password: oldPassword,
          password,
          confirm_password: confirmPassword,
        },
      });
    });
  };

  const handleClose = () => {
    setA2HSDismissedForWS(workspace_id);
    setOpenDrawer(false);
  };

  const logout = () => {
    logoutRedirect();
  };

  useEffect(() => {
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceDetails, site, loadImage]);

  useEffect(() => {
    if (!isOpenModal) {
      clearChangePasswordModalValues();
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (workspace_id && user?._id) {
      loadPlanDetails(workspace_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspace_id, user?._id]);

  useEffect(() => {
    if (workspace_id && window.innerWidth < 480) {
      setOpenDrawer(!isA2HSDismissedForWS(workspace_id));
    }
  }, [workspace_id]);

  useEffect(() => {
    if (planDetails?.active_plan?.plan_details?.pricing?.type !== "no_charge" && planDetails?.active_plan?.payment_required) {
      setWorspacePaymentModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planDetails?.active_plan]);

  const page_type = useActivePage({
    menus: headerMenus,
    page_id: content_value,
    document_id: content_value,
    form_id: content_value,
  });

  useEffect(() => {
    setParams({ ...params, page_type });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page_type]);

  return (
    <>
      <div className={classNames(isNotification ? classNames("flex max-h-[calc(100vh-4rem)] flex-shrink flex-grow flex-col") : "flex min-h-full w-full bg-leftNavColor")}>
        {mordernDesign && (
          <div
            className={classNames("fixed left-0 top-0 z-[49] block h-full w-screen bg-black transition-all duration-200 xl:z-[39] xl:hidden", isMenu ? "visible opacity-80" : "invisible opacity-0")}
            onClick={() => setIsMenu(!isMenu)}></div>
        )}
        <div
          className={classNames("fixed left-0 z-50 h-full w-full bg-leftNavColor transition-all duration-200 xl:z-40", !isMenu || isOuterPage ? "-translate-x-full" : "translate-x-0", device === "mobile" && "top-0 z-[61]")}
          style={{ maxWidth: device === "desktop" ? sidepanelWidth : 310 }}>
          {workspace_id && workspaceDetails._id && workspaces.length > 1 ? (
            <div className={classNames("relative z-20 hidden select-none pb-2 xl:block xl:pt-2", menuType === "vertical" && menus?.length === 1 && "pl-2", menus?.length > 1 && menuType === "horizontal" && "pl-2")}>
              <DropdownWrapper
                key={workspaces?.length}
                mordernDesign={mordernDesign}
                data={workspaces.map((workspace) => ({
                  ...workspace,
                  image: workspace.square_logo || workspace.image_logo || workspace.image_favicon,
                }))}
                onClick={clickWorkspace}
                currentId={extractWorkspaceName()}
                content={
                  <>
                    {currentLogo ? (
                      <div className="mb-[1px] flex h-12 py-[2px] sm:h-14">
                        <Image
                          src={currentLogo}
                          alt={"logo"}
                          width="100%"
                          height="100%"
                          classes="object-contain object-top object-left max-h-full max-w-full !h-auto !w-auto"
                          hideImageOnError
                        />
                      </div>
                    ) : (
                      <div className="flex h-full w-full items-center justify-center rounded-lg border border-transparent px-3 py-2 font-medium text-leftNavTextColor transition-all  hover:shadow">
                        Switch workspace
                        <RectangleStackIcon className="ml-[8px] h-5 w-5" />
                      </div>
                    )}
                  </>
                }
                buttonLabel="Workspaces"
                buttonClass="w-full max-w-sm"
                buttonIcon={true}
                dropdownContainer="ml-11"
              />
            </div>
          ) : (
            <div className="pb-2 pr-8 pt-2">
              <div className="mb-[1px] flex h-12 px-4 py-[2px] sm:h-14">
                <Image
                  src={currentLogo}
                  alt={"logo"}
                  width="100%"
                  height="100%"
                  effect="blur"
                  classes="object-contain object-left"
                  hideImageOnError
                />
              </div>
            </div>
          )}
          <LeftNavigationMenu
            mordernDesign={mordernDesign}
            sidepanelWidth={sidepanelWidth}
            isMenu={isMenu}
            setIsMenu={setIsMenu}
            menus={menus}
            setMenus={setMenus}
            simulatedMenus={simulatedMenus}
            setSimulatedMenus={setSimulatedMenus}
            keyword={keyword}
            setKeyword={setKeyword}
            handleMenuClick={handleMenuClick}
            menusLoaded={menusLoaded}
            isNotification={isNotification}
          />

          {user?._id && (
            <div className="animate-fade-in hidden px-4 xl:block">
              <UserDropdown
                data={userMenu}
                showName={!workspaceDetails?.notification_banner_enable}
                xPlacement={mordernDesign ? "left" : "right"}
                mordernDesign={mordernDesign}
              />
            </div>
          )}
        </div>
        <div
          className={classNames("flex w-full flex-grow flex-col justify-center space-y-2 bg-leftNavColor transition-all xl:pt-2", !window.location.href.includes("/payment-required") && "xl:pl-2")}
          style={{
            maxWidth: device === "mobile" || !isMenu ? "100%" : `calc(100% - ${sidepanelWidth})`,
            marginLeft: device === "mobile" || !isMenu ? 0 : `${sidepanelWidth}`,
          }}>
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex items-center xl:hidden">
              {!(!workspaceDetails?._id || !menus?.length || menus?.length === 1) && !payment_required && (
                <button
                  onClick={() => setIsMenu(!isMenu)}
                  className={classNames("group group ml-2 flex h-9 w-9 items-center justify-center rounded-md transition-all", menuType === "vertical" ? "" : "md:hidden")}>
                  <Bars3BottomLeftIcon className="h-7 w-7 text-leftNavTextColor transition-all group-hover:stroke-2" />
                </button>
              )}

              {menus?.length <= 1 && content_value && (
                <motion.button
                  key="slide-button"
                  initial={{ x: -20, opacity: 0, scale: 0.9 }}
                  animate={{ x: 0, opacity: 1, scale: 1 }}
                  exit={{ x: -20, opacity: 0, scale: 0.9 }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate(`/workspace/${workspace_id}/embed`)}
                  data-tooltip-id="back-to-dashboard-tip"
                  data-tooltip-content="Back to dashboard"
                  transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 30,
                    mass: 0.8,
                  }}
                  className={classNames("group relative ml-3 flex h-10 w-10 items-center justify-center rounded-xl", "border border-white/20 bg-leftNavActiveColor shadow-sm backdrop-blur-md", "transition-all duration-200 hover:shadow-md")}>
                  <ArrowUturnLeftIcon className="h-5 w-5 text-headerTextColor transition-transform duration-200 group-hover:-translate-x-0.5" />
                </motion.button>
              )}

              <Tooltip
                id="back-to-dashboard-tip"
                place="bottom"
                delayShow={250}
                className="!rounded-md !px-3 !py-2 !text-xs !shadow-lg"
                style={{ background: "rgba(0,0,0,0.9)", color: "white", zIndex: 9999 }}
              />

              {workspace_id && workspaceDetails._id && workspaces.length > 1 ? (
                <div className={classNames("relative z-20 pt-2", menuType === "vertical" && menus?.length === 1 && "pl-2", menus?.length > 1 && menuType === "horizontal" && "pl-2")}>
                  <DropdownWrapper
                    key={workspaces?.length}
                    mordernDesign={mordernDesign}
                    data={workspaces.map((workspace) => ({
                      ...workspace,
                      image: workspace.square_logo || workspace.image_logo || workspace.image_favicon,
                    }))}
                    onClick={clickWorkspace}
                    currentId={extractWorkspaceName()}
                    content={
                      <>
                        {currentLogo ? (
                          <div className="mb-[1px] flex h-12 py-[2px] sm:h-14">
                            <Image
                              src={currentLogo}
                              alt={"logo"}
                              width="100%"
                              height="100%"
                              classes="object-contain object-left max-h-full max-w-full !h-auto !w-auto"
                              hideImageOnError
                            />
                          </div>
                        ) : (
                          <div className="flex h-full w-full items-center justify-center rounded-lg border border-transparent px-3 py-2 font-medium   text-leftNavTextColor transition-all  hover:shadow">
                            Switch workspace
                            <RectangleStackIcon className="ml-[8px] h-5 w-5" />
                          </div>
                        )}
                      </>
                    }
                    buttonLabel="Workspaces"
                    buttonClass="w-full max-w-sm"
                    buttonIcon={true}
                    dropdownContainer="sm:ml-11"
                  />
                </div>
              ) : (
                <div className="ml-2 h-12 sm:h-[52px] sm:py-[3px]">
                  <Image
                    src={currentLogo}
                    alt={"logo"}
                    width="100%"
                    height="100%"
                    effect="blur"
                    classes="object-contain object-left"
                    hideImageOnError
                  />
                </div>
              )}
            </div>
            {user?._id && (
              <div className="animate-fade-in block px-4 xl:hidden">
                <UserDropdown
                  data={userMenu}
                  showName={!workspaceDetails?.notification_banner_enable}
                  xPlacement={mordernDesign ? "left" : "right"}
                  mordernDesign={mordernDesign}
                />
              </div>
            )}
            {!window.location.href.includes("/payment-required") && headerMenus.length > 0 && (
              <div className={classNames("ml-auto hidden w-full flex-shrink-0 justify-end xl:flex", isNotification ? "h-9 items-start" : "")}>
                <HeaderMenus
                  menus={headerMenus}
                  setOverflowedHeaderMenus={setOverflowedHeaderMenus}
                  mordernDesign={mordernDesign}
                />
              </div>
            )}
          </div>

          <div
            className={classNames(
              "scrollbar relative z-0 w-full flex-shrink flex-grow bg-backgroundColor xl:rounded-tl-2xl xl:shadow",
              window.location.href.includes("/payment-required") ? "overflow-hidden" : "overflow-auto",
              isNotification && classNames(!window.location.href.includes("/payment-required") && headerMenus.length > 0 ? classNames(device === "desktop" ? "max-h-[calc(100vh-7.25rem)]" : "max-h-[calc(100vh-7.1rem)] sm:max-h-[calc(100vh-7.75rem)]") : "max-h-[calc(100vh-5rem)]"),
            )}>
            <Outlet />
          </div>
        </div>
      </div>

      <Modal
        title="Change Password"
        isOpen={isOpenModal}
        onSuccess={changePassword}
        onCancel={() => setIsOpenModal(false)}
        defaultOptions={{
          onSuccessLoaderVisible: changePasswordLoading,
          onSuccessLoaderStart: changePasswordLoading,
          successButtonDisabled: changePasswordLoading || passwordValidation,
          onSuccessButtonSuccess: changePasswordSuccess,
        }}>
        <div className="mb-3">
          <Input
            inline={true}
            inputValue={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            label={"Current Password *"}
            inputType={"password"}
            inputName={"password"}
          />
        </div>
        <hr className="my-5" />
        <ResetPasswordForm
          password={password}
          confirmPassword={confirmPassword}
          setPassword={setPassword}
          setConfirmPassword={setConfirmPassword}
          policy={site?.password_policy}
        />
      </Modal>
      <SlideOver
        size="5xl"
        title="Settings"
        description="Manage your settigs and configurations."
        isOpen={settingsSlider}
        handleClose={() => setSettingsSlider(false)}>
        <Settings />
      </SlideOver>
      {!loading && !window.location.href.includes("/workspace-paused") && (
        <CustomModal
          size="xxl"
          title={planDetails?.active_plan ? (planDetails?.active_plan?.payment_required ? "Plan purchase" : "Manage Payments") : ""}
          hideImage={false || (planDetails && !planDetails?.active_plan?.payment_required)}
          secondaryTitle={workspaceDetails?.name || ""}
          hideCrossIcon={!planDetails?.active_plan || planDetails?.active_plan?.payment_required}
          onClose={() => setWorspacePaymentModalOpen(false)}
          isOpen={workspacePaymentModalOpen}>
          {isExtension ? (
            <div className="flex w-full flex-col items-center justify-center px-2 py-12 sm:px-6 lg:px-8">
              <div className="flex flex-col items-center space-y-6 sm:mx-auto sm:w-full sm:max-w-xl">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 sm:text-3xl">This workspace is under a subscription</h2>
                <div className="text-regular mt-1 text-center text-gray-600">Please contact your administrator for more details. </div>
              </div>
            </div>
          ) : (
            <ManagePayments
              loading={loading}
              planDetails={planDetails}
              loadPlanDetails={loadPlanDetails}
            />
          )}
        </CustomModal>
      )}
      <SlideOver
        isOpen={openDrawer}
        handleClose={handleClose}
        hideHeader={true}
        onOpenChange={setOpenDrawer}
        position={"bottom"}>
        <AddToHomeScreen
          site={site}
          onClose={handleClose}
          workspaceDetails={workspaceDetails}
        />
      </SlideOver>
    </>
  );
};

export default MordernDesign;
